module.exports = __webpack_public_path__ + "static/media/megabus-logo.15132b4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/megabus-logo.svg
// module id = 163
// module chunks = 0